import * as STD from '@emersya/mpa-std';

import {Basket} from './Basket';
import {Option} from './Option';
import Product from './Product';
import Part from './Part';
import Component from './Component';
import Contact from './Contact';
import Tax from './Tax';
import Price from './Price';
import Pricing from './Pricing';
import Reference from './Reference';

export * from './Basket';
export {default as Product} from './Product';
export {default as Part} from './Part';
export * from './Option';
export {default as Component} from './Component';
export {default as Contact} from './Contact';
export {default as Tax} from './Tax';
export {default as Price} from './Price';
export {default as Pricing} from './Pricing';
export {default as Reference} from './Reference';

declare global {
	interface Window {
		readonly BasketNS: {
			readonly Basket: typeof Basket;
			readonly Product: typeof Product;
			readonly Part: typeof Part;
			readonly Option: typeof Option;
			readonly Component: typeof Component;
			readonly Contact: typeof Contact;
			readonly Tax: typeof Tax;
			readonly Price: typeof Price;
			readonly Pricing: typeof Pricing;
			readonly Reference: typeof Reference;
		};
	}
}

(<STD.object.SetWritable<typeof window, 'BasketNS'>>window).BasketNS = {
	Basket,
	Product,
	Part,
	Option,
	Component,
	Contact,
	Tax,
	Price,
	Pricing,
	Reference,
};
